import React, { FC } from 'react';
import { EPurchaseOrderStatus, EPurchaseOrderStatusLabel } from 'entities/PurchaseOrder/PurchaseOrder.models';
import { PurchaseOrderStatusDot } from 'entities/PurchaseOrder/components/PurchaseOrderStatusDot';

interface IComponentProps {
  status: string;
}

export const PurchaseOrderStatus: FC<IComponentProps> = ({ status }) => {
  const color = () => {
    switch (status) {
      case EPurchaseOrderStatus.ForApproval: {
        return 'yellow';
      }
      case EPurchaseOrderStatus.Preparing: {
        return 'blue';
      }
      case EPurchaseOrderStatus.InTransit: {
        return 'purple';
      }
      case EPurchaseOrderStatus.Delivered: {
        return 'green';
      }
      case EPurchaseOrderStatus.Canceled: {
        return 'red';
      }
      default: {
        return 'gray';
      }
    }
  };

  return (
    <div className={`purchase-order-status ${color()}`}>
      <PurchaseOrderStatusDot status={status} />
      <span className="ff-regular fs-xxxs">{EPurchaseOrderStatusLabel[status as EPurchaseOrderStatus]}</span>
    </div>
  );
};
